if (!customElements.get('molivrae-header')) {
  customElements.define('molivrae-header', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.menus = [...this.querySelectorAll('.mv-mega')];
      this.toggle = this.querySelector('.mv-menu-toggle');
      this.desktop = window.matchMedia('(min-width: 990px)');
      this.closeMenus = (except) => this.menus.forEach(menu => { if (menu !== except) menu.open = false; });
      this.closeMobile = (focus = false) => {
        this.removeAttribute('data-mobile-open');
        this.toggle.setAttribute('aria-expanded', 'false');
        document.body.style.overflow = this.previousOverflow || '';
        this.closeMenus();
        if (focus) this.toggle.focus();
      };
      this.toggle.addEventListener('click', () => {
        if (this.hasAttribute('data-mobile-open')) return this.closeMobile(true);
        this.previousOverflow = document.body.style.overflow;
        this.setAttribute('data-mobile-open', '');
        this.toggle.setAttribute('aria-expanded', 'true');
        document.body.style.overflow = 'hidden';
        this.menus[0]?.querySelector('summary').focus();
      }, options);
      this.menus.forEach(menu => {
        const summary = menu.querySelector('summary');
        menu.addEventListener('pointerenter', event => {
          if (!this.desktop.matches || event.pointerType !== 'mouse') return;
          clearTimeout(this.leaveTimer);
          this.closeMenus(menu);
          menu.open = true;
          this.querySelector('.mv-market')?.removeAttribute('open');
        }, options);
        menu.addEventListener('pointerleave', event => {
          if (!this.desktop.matches || event.pointerType !== 'mouse') return;
          this.leaveTimer = setTimeout(() => { if (!menu.contains(document.activeElement)) menu.open = false; }, 160);
        }, options);
        summary.addEventListener('click', () => this.closeMenus(menu), options);
        menu.addEventListener('focusout', () => {
          setTimeout(() => { if (this.desktop.matches && !menu.contains(document.activeElement) && !menu.matches(':hover')) menu.open = false; }, 0);
        }, options);
      });
      this.addEventListener('keydown', event => {
        if (event.key === 'Escape' && !this.querySelector('dialog[open]')) {
          const openMenu = this.menus.find(menu => menu.open);
          if (this.hasAttribute('data-mobile-open')) this.closeMobile(true);
          else { this.closeMenus(); openMenu?.querySelector('summary').focus(); this.querySelector('.mv-market')?.removeAttribute('open'); }
        }
        if (event.key === 'Tab' && this.hasAttribute('data-mobile-open') && !this.querySelector('dialog[open]')) {
          const focusable = [...this.querySelectorAll('a[href],button,summary,input,select')].filter(node => node.getClientRects().length && !node.closest('dialog:not([open])'));
          const first = focusable[0], last = focusable[focusable.length - 1];
          if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
          if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
        }
      }, options);
      document.addEventListener('pointerdown', event => {
        if (!this.contains(event.target)) { this.closeMenus(); this.querySelector('.mv-market')?.removeAttribute('open'); if (this.hasAttribute('data-mobile-open')) this.closeMobile(); }
      }, options);
      this.querySelectorAll('[data-mv-dialog]').forEach(trigger => {
        trigger.addEventListener('click', event => {
          const dialog = document.getElementById(trigger.dataset.mvDialog);
          if (!dialog?.showModal) return;
          event.preventDefault();
          this.closeMenus();
          dialog.showModal();
          dialog.querySelector('input[type=search]')?.focus();
        }, options);
      });
      this.querySelectorAll('dialog').forEach(dialog => {
        dialog.querySelector('[data-mv-close]').addEventListener('click', () => dialog.close(), options);
        dialog.addEventListener('click', event => {
          const rect = dialog.getBoundingClientRect();
          if (event.target === dialog && (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom)) dialog.close();
        }, options);
      });
      this.querySelector('[data-mv-cart]').addEventListener('click', event => {
        const cart = document.getElementById('cart-drawer');
        if (typeof cart?.open !== 'function') return;
        event.preventDefault();
        this.closeMobile();
        cart.open();
      }, options);
      document.addEventListener('shopify:cart:lines-update', event => {
        event.promise?.then(({ cart, detail }) => {
          if (!this.isConnected) return;
          const count = cart?.totalQuantity ?? detail?.itemCount;
          if (typeof count !== 'number') return;
          const badge = this.querySelector('.mv-cart-count');
          badge.textContent = String(count);
          badge.hidden = count === 0;
        }).catch(() => {});
      }, options);
      this.resizeObserver = new ResizeObserver(() => {
        const height = this.getBoundingClientRect().height;
        document.body.style.setProperty('--header-height', `${height}px`);
        document.body.style.setProperty('--header-group-height', `${height}px`);
      });
      this.resizeObserver.observe(this);
      this.desktop.addEventListener('change', () => this.closeMobile(), options);
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.resizeObserver?.disconnect();
      clearTimeout(this.leaveTimer);
      if (this.hasAttribute('data-mobile-open')) document.body.style.overflow = this.previousOverflow || '';
    }
  });
}
